import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { useHistory, useParams } from "react-router-dom";
import star from "../../../assets/images/pendingIcons/star.png";
import axios from "axios";
import { Markup } from "interweave";
import noImage from "../../../assets/images/settings/no-image.png";
import icon2 from "../../../assets/images/Rounds/icons/finish 1.png";
import icon3 from "../../../assets/images/Rounds/icons/flag 1.png";
import moment from "moment";
import { Accordion } from "react-bootstrap";
import swal from "sweetalert";
import cup from "../../../assets/images/page 1.png";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Tab, Nav } from "react-bootstrap";
import ReUseableSingleRoundTab from "../../Reuseable/ReUseableSingleRoundTab";
import LoaderPost from "../../Reuseable/LoaderPost";
import MessageText from "../../Reuseable/MessageText";
import { serverInfo } from "../../../App";
import { useContext } from "react";

const StarRoundInstructionFeedback = () => {

  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);

  const { slug } = useParams();
  const [checkData, setCheckData] = React.useState(0);
  const [audition, setAudition] = React.useState({});
  const [runningInstructionInfo, setRunningInstructionInfo] =
    React.useState(null);
  const [file, setFile] = useState("");
  const [imageData, setImageData] = useState("");
  const [fileVideo, setFileVideo] = useState("");
  const [filePdf, setFilePdf] = useState("");
  const [videoFile, setVideoFile] = useState("");
  const [convertedContent, setConvertedContent] = useState(null);
  const [errorList, setErrorList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeRound, setActiveRound] = React.useState(0);
  const [rounds, setRounds] = useState([]);
  const [roundInstructionByStar, setRoundInstructionByStar] = useState([]);

  const checkDataHandler = (data) => {
    setCheckData(data.id);
    setRunningInstructionInfo(data);
  };

  const handleImageChange = (file) => {
    setFile(URL.createObjectURL(file[0]));
    setImageData(file[0]);
  };
  const handleVideoChange = (file) => {
    setFileVideo(file[0]);
    setVideoFile(URL.createObjectURL(file[0]));
  };

  const handlePdfChange = (file) => {
    setFilePdf(file[0]);
  };

  const updateRoundInstructionInfo = (e) => {
    e.preventDefault();
    const fData = new FormData();
    fData.append("audition_id", audition.id);
    fData.append("round_info_id", activeRound);
    fData.append("instruction", convertedContent);
    fData.append("video", fileVideo);
    fData.append("image", imageData);
    fData.append("pdf", filePdf);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .post(`/api/audition-admin/audition/round-instruction/update`, fData)
        .then((res) => {
          if (res.data.status === 200) {
            swal("Success", res.data.message, "success");
            getSingleAuditionInstructionInfo();
          } else {
            setErrorList(res.data.validation_errors);
          }
        });
    });
  };

  const getSingleAuditionInstructionInfo = () => {
    axios.get(`/api/audition-admin/audition-event/with-rounds/${slug}`).then((res) => {
      if (res.data.status === 200) {
        setAudition(res.data.event);
        //if error then add info
        setRounds(res.data.event?.audition_round);
        setActiveRound(res.data.event?.active_round_info_id);
      }
    });
  };

  const getRoundInstructionByJudges = () => {
    setLoading(true);
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .get(
          `/api/audition-admin/audition/round-instruction-judges/${audition.id}/${activeRound}`
        )
        .then((res) => {
          if (res.data.status === 200) {
            setRoundInstructionByStar(res.data.round_ins_send_info);
            setRunningInstructionInfo(res.data?.round_ins_send_info[0]);
            setCheckData(res.data?.round_ins_send_info[0]?.id);

            if (res.data.round_instruction?.send_to_manager == 1) {
              setConvertedContent(res.data.round_instruction?.instruction);
              setVideoFile(
                videoCdnUrl + res.data.round_instruction?.video
              );
              setFile(
                imageCdnUrl + res.data.round_instruction?.image
              );
            }
          }
          setLoading(false);
        });
    });
  };

  useEffect(() => {
    getSingleAuditionInstructionInfo();
  }, [slug]);

  useEffect(() => {
    getRoundInstructionByJudges();
  }, [activeRound]);

  return (
    <>
      {loading === true ? (
        <LoaderPost />
      ) : (
        <>
          <Tab.Container id="left-tabs-example" defaultActiveKey={activeRound}>
            <div className="container-lg">
              <Nav variant="pills">
                <div className="row">
                  {rounds &&
                    rounds.map((auditionRound, index) => (
                      <ReUseableSingleRoundTab
                        key={index}
                        auditionRound={auditionRound}
                        setActiveRound={setActiveRound}
                      />
                    ))}
                </div>
              </Nav>
              <div className="my-4"></div>
            </div>
          </Tab.Container>

          {roundInstructionByStar.length === 0 ? (
            <MessageText
              title={"Judge Instruction Not Found for This Round!"}
            />
          ) : (
            <>
              <div className="my-2">
                <div className="accordion" id="accordionExample">
                  <div
                    className="accordion-item mb-1"
                    style={{ border: "none", outline: "none" }}
                  >
                    <h4 className="accordion-header" id="headingOne">
                      <button
                        className="accordion-button card-bg  text-light"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                        style={{ boxShadow: "none" }}
                      >
                        Start status
                      </button>
                    </h4>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse show"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body bg-dark">
                        {/* <Status /> */}
                        <div>
                          <div className="d-flex justify-content-between flex-wrap">
                            <div
                              className=""
                              style={{
                                height: "200px",
                                width: "230px",
                                borderRadius: "20px",
                              }}
                            >
                              <img src={star} alt="" className="h-100 w-100" />
                            </div>
                            {roundInstructionByStar &&
                              roundInstructionByStar.map((info, index) => (
                                <div
                                  key={index}
                                  className={
                                    checkData === info?.id
                                      ? "card bg-warning"
                                      : "card star-cardColor"
                                  }
                                  style={{
                                    height: "200px",
                                    width: "230px",
                                    borderRadius: "20px",
                                  }}
                                >
                                  <div
                                    className="card-body"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => checkDataHandler(info)}
                                  >
                                    <div className="d-flex justify-content-start">
                                      {info.star ? (
                                        <small className="text-bold text-light">
                                          {info.star?.first_name +
                                            " " +
                                            info.star?.last_name}
                                        </small>
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                    <div className="d-flex justify-content-end">
                                      {info ? (
                                        <small className="text-bold star-pendingColor">
                                          {info.status === 0
                                            ? "Pending"
                                            : info.status === 1
                                              ? "Accpted"
                                              : null}
                                          *
                                        </small>
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                    <div className="text-center d-flex justify-content-center">
                                      <img
                                        src={
                                          info.star?.image
                                            ? imageCdnUrl + info.star?.image
                                            : noImage
                                        }
                                        style={{
                                          height: "100px",
                                          width: "100px",
                                          borderRadius: "50%",
                                        }}
                                        alt="Star"
                                      />
                                    </div>
                                  </div>
                                </div>
                              ))}
                          </div>

                          {runningInstructionInfo &&
                            runningInstructionInfo?.status === 0 ? (
                            <MessageText
                              title={"Please Wait for Judge Feedback...."}
                            />
                          ) : (
                            <>
                              <div className="container my-3">
                                <div
                                  style={{
                                    border: "2px solid gold",
                                    borderRadius: "10px",
                                  }}
                                >
                                  <div className="p-4">
                                    <h5 className="text-warning">Title</h5>
                                    <div className="card star-cardColor2">
                                      <div className="card-body ">
                                        <p className="text-light">
                                          {audition && audition.title}
                                        </p>
                                      </div>
                                    </div>

                                    <div className="mt-4">
                                      <h5 className="text-warning">
                                        Instructions
                                      </h5>
                                      <div>
                                        {runningInstructionInfo && (
                                          <p className="text-light my-2">
                                            <Markup
                                              content={
                                                runningInstructionInfo?.instruction
                                              }
                                            />
                                          </p>
                                        )}
                                      </div>
                                    </div>

                                    <div className="container topBannerVideoRound">
                                      <img
                                        style={{ height: "350px" }}
                                        src={
                                          runningInstructionInfo?.image
                                            ? imageCdnUrl + runningInstructionInfo?.image
                                            : noImage
                                        }
                                        alt=""
                                        className="img-fluid w-100"
                                      />
                                    </div>

                                    <div className="container topBannerVideoRound my-4">
                                      <ReactPlayer
                                        url={
                                          runningInstructionInfo?.video
                                            ? videoCdnUrl + runningInstructionInfo?.video
                                            : "https://youtu.be/dgfTiONcnTc"
                                        }
                                        playing={false}
                                        volume={1}
                                        width="100%"
                                        controls={true}
                                        autoplay
                                      />
                                    </div>

                                    <section className="container d-sm-block d-md-flex justify-content-between">
                                      <div className="status-start d-flex mb-2">
                                        <div className="img-icon-status  d-flex justify-content-center align-items-center ms-3">
                                          <div>
                                            <img
                                              src={icon3}
                                              className="statusImg"
                                              alt=""
                                            />
                                          </div>
                                        </div>
                                        <div className="img-icon-status  d-flex justify-content-center align-items-center mx-3">
                                          <div>
                                            <small className="text-light">
                                              Starts
                                            </small>
                                            <h5 className="text-light fontSizeStatus">
                                              {moment(
                                                audition?.info?.event_start_date
                                              ).format("LL")}
                                            </h5>
                                          </div>
                                        </div>
                                      </div>

                                      <div className="status-start2 d-flex mb-2">
                                        <div className="img-icon-status  d-flex justify-content-center align-items-center ms-3">
                                          <div>
                                            <img
                                              src={icon2}
                                              className="statusImg"
                                              alt=""
                                            />
                                          </div>
                                        </div>
                                        <div className="img-icon-status  d-flex justify-content-center align-items-center mx-3">
                                          <div>
                                            <small className="text-light">
                                              Ends
                                            </small>
                                            <h5 className="text-light fontSizeStatus">
                                              {" "}
                                              {moment(
                                                audition?.info?.event_end_date
                                              ).format("LL")}
                                            </h5>
                                          </div>
                                        </div>
                                      </div>
                                    </section>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="accordion my-3" id="accordionExample1">
                  <div
                    className="accordion-item mb-1"
                    style={{ border: "none", outline: "none" }}
                  >
                    <h5 className="accordion-header" id="headingTwo">
                      <button
                        className="accordion-button card-bg  text-light"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                        style={{ boxShadow: "none" }}
                      >
                        Round Registration Form for User
                      </button>
                    </h5>
                    <div
                      id="collapseTwo"
                      className="accordion-collapse collapse show"
                      aria-labelledby="headingTwo"
                      data-bs-parent="#accordionExample1"
                    >
                      <div className="accordion-body bg-dark">
                        <div className="d-flex px-4">
                          <div className="faTrophy p-2">
                            <img
                              src={cup}
                              alt=""
                              className="mt-1"
                              width="30px"
                            />{" "}
                            <span className="text-waning p-2 fw-bolder">
                              Registration Form for User
                            </span>
                          </div>
                        </div>
                        <div className="my-2">
                          <form
                            onSubmit={updateRoundInstructionInfo}
                            id="input_form"
                            encType="multipart/form-data"
                          >
                            <div className="row ms-5">
                              <div className="form-group row mt-3">
                                <label
                                  for="staticEmail"
                                  className="col-sm-2 col-form-label text-light "
                                >
                                  Post Title
                                </label>
                                <div className="col-sm-8">
                                  <input
                                    type="text"
                                    className="form-control Frombtns"
                                    value={audition.title}
                                    readOnly
                                  />
                                </div>
                              </div>

                              <div className="form-group row mt-3">
                                <label
                                  for="inputPassword"
                                  className="col-sm-2 col-form-label text-light "
                                >
                                  Instruction
                                </label>
                                <div className="col-sm-8">
                                  <CKEditor
                                    editor={ClassicEditor}
                                    data={convertedContent}
                                    onChange={(audition, editor) => {
                                      const data = editor.getData();
                                      setConvertedContent(data);
                                    }}
                                  />
                                  <span className="text-danger">
                                    {errorList.instruction}
                                  </span>
                                </div>
                              </div>
                              <div className="form-group row mt-3">
                                <label
                                  for="staticEmail"
                                  className="col-sm-3 col-form-label text-light "
                                >
                                  Upload Video
                                </label>

                                <div className="col-sm-7 mb-2">
                                  <div className="row my-4">
                                    <div className="col-md-10">
                                      {videoFile ? (
                                        <>
                                          <ReactPlayer
                                            url={videoFile}
                                            // width="100%"
                                            controls={true}
                                            height="35vh"
                                          />
                                        </>
                                      ) : (
                                        <></>
                                      )}
                                      <input
                                        type="file"
                                        name="file"
                                        id="setFile"
                                        className="inputfile w-25"
                                        accept="video/mp4"
                                        onChange={(e) =>
                                          handleVideoChange(e.target.files)
                                        }
                                      />

                                      <label for="setFile">
                                        <i className="fas fa-cloud-upload-alt"></i>{" "}
                                        Upload Video
                                      </label>
                                      <span className="text-danger">
                                        {errorList.video}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="form-group row mt-3">
                                <label
                                  for="staticEmail"
                                  className="col-sm-3 col-form-label text-light "
                                >
                                  Upload Banner
                                </label>

                                <div className="col-sm-7 mb-2">
                                  <div className="row my-4">
                                    {file ? (
                                      <img
                                        src={file}
                                        alt="..."
                                        className="demo-preview-image img-fluid"
                                      />
                                    ) : (
                                      ""
                                    )}
                                    <div className="col-md-10">
                                      <input
                                        type="file"
                                        name="imageFile"
                                        id="imageFile"
                                        className="inputfile w-25"
                                        accept="image/jpg,image/jpeg, image/png"
                                        onChange={(e) =>
                                          handleImageChange(e.target.files)
                                        }
                                      />

                                      <label for="imageFile">
                                        <i className="fas fa-cloud-upload-alt"></i>{" "}
                                        Upload Image
                                      </label>
                                      <span className="text-danger">
                                        {errorList.image}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="form-group row mt-3">
                                <label
                                  for="staticEmail"
                                  className="col-sm-3 col-form-label text-light "
                                >
                                  Instruction pdf for the post
                                </label>

                                <div className="col-sm-7 mb-2">
                                  <div className="row d-flex justify-content-end my-4">
                                    <div className="col-md-2 text-white"></div>
                                    <div className="col-md-3 inputeParent">
                                      <input
                                        type="file"
                                        name="pdfFile"
                                        id="pdfFile"
                                        accept=".pdf"
                                        className="inputfile w-25"
                                        onChange={(e) =>
                                          handlePdfChange(e.target.files)
                                        }
                                      />
                                      <label for="pdfFile">
                                        <i className="fa-solid fa-file-pdf"></i>{" "}
                                        1 MB Maximum
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="row justify-content-end my-4">
                                <div className="col-md-3 text-left">
                                  <button
                                    className="btn btn-warning px-4 fw-bold"
                                    type="submit"
                                  >
                                    Confirm
                                  </button>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};

export default StarRoundInstructionFeedback;
